import GLightbox from 'glightbox'

export default function () {
  GLightbox({
    selector: '.js-glightbox',
  })

  GLightbox({
    selector: '.js-glightbox-video',
    videosWidth: '1440',
    plyr: {
      config: {
        ratio: '16:9', // or '4:3'
        muted: true,
        hideControls: true,
        youtube: {
          noCookie: true,
          rel: 0,
          showinfo: 0,
          iv_load_policy: 3,
        },
      },
    },
  })

  const customLightboxHTML = `
    <div id="glightbox-body" class="glightbox-container">
      <div class="gloader visible"></div>
      <div class="goverlay"></div>
      <div class="gcontainer">
        <div class="gcontainer-slider">
          <div id="glightbox-slider" class="gslider"></div>
          <div class="glightbox-counter">
            <p> photos</p>
          </div>
          <div class="buttons-nav">
            <button class="gnext gbtn" tabindex="0" data-taborder="1" aria-label="${window.ICL_LANGUAGE_CODE == 'en' ? 'Next' : 'Suivant'}" data-glightbox="next">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                <path d="M7.80591 1L6.70082 2.07046L11.0083 6.24296H0L5.26949e-07 7.75682L11.0085 7.75682L6.70082 11.9295L7.80591 13L14 7L7.80591 1Z" fill="#1E1E1E"/>
              </svg>
            </button>
            <button class="gprev gbtn" tabindex="1" data-taborder="2" aria-label="${window.ICL_LANGUAGE_CODE == 'en' ? 'Previous' : 'Précédent'}" data-glightbox="prev">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                <path d="M7.80591 1L6.70082 2.07046L11.0083 6.24296H0L5.26949e-07 7.75682L11.0085 7.75682L6.70082 11.9295L7.80591 13L14 7L7.80591 1Z" fill="#1E1E1E"/>
              </svg>
            </button>
          </div>
        </div>
        <button class="gclose gbtn" tabindex="2" data-taborder="3" aria-label="${window.ICL_LANGUAGE_CODE == 'en' ? 'Close' : 'Fermer'}" data-glightbox="close">
          <svg viewBox="0 0 14 13" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00006 7.56066L2.03039 12.5303L0.969727 11.4697L5.9394 6.5L0.969727 1.53033L2.03039 0.469666L7.00006 5.43934L11.9697 0.469666L13.0304 1.53033L8.06072 6.5L13.0304 11.4697L11.9697 12.5303L7.00006 7.56066Z" fill="white"/>
          </svg>
        </button>
      </div>
    </div>`

  let customSlideHTML = `
    <div class="gslide">
      <div class="gslide-inner-content">
        <div class="ginner-container">
          <div class="gslide-media">
            <div class="gslide-description">
              <div class="gdesc-inner">
                <p class="gslide-title"></p>
                <div class="gslide-desc"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`

  const customGlightbox = GLightbox({
    selector: '.js-glightbox-custom',
    lightboxHTML: customLightboxHTML,
    slideHTML: customSlideHTML,
    zoomable: false,
    skin: 'custom',
  })

  customGlightbox.on('open', function () {
    const glightboxElements = document.querySelectorAll(
      '.gcontainer-slider .gslide',
    )
    const totalSlides = glightboxElements.length

    const counterDiv = document.querySelector('.glightbox-counter p')
    if (counterDiv) {
      counterDiv.textContent = `${totalSlides} ${totalSlides > 1 ? 'photos' : 'photo'}`
    }
  })
}
